var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarkerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78751 0.162109C3.55618 0.162109 0.133942 3.45602 0.133942 7.52867C0.133942 13.0536 7.78751 21.2094 7.78751 21.2094C7.78751 21.2094 15.4411 13.0536 15.4411 7.52867C15.4411 3.45602 12.0188 0.162109 7.78751 0.162109ZM7.78751 10.1596C6.27867 10.1596 5.05409 8.98094 5.05409 7.52867C5.05409 6.07641 6.27867 4.89776 7.78751 4.89776C9.29636 4.89776 10.5209 6.07641 10.5209 7.52867C10.5209 8.98094 9.29636 10.1596 7.78751 10.1596Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerLight);
export default __webpack_public_path__ + "static/media/map-marker-light.fcefe047422709fa98ad23fdfa6a7a12.svg";
export { ForwardRef as ReactComponent };